import React from 'react';
var DarkContext = React.createContext('light');
export default DarkContext;
//# sourceMappingURL=DarkContext.js.map